import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';

import {
    DefaultTableProvider,
    DefaultTableModalProvider,
    LadderTableProvider,
    RankingsTableProvider,
    PlayerStatsTableProvider
} from '../../custom-table/js/providers';
import {
    StatsLeadersProvider,
    StatsProHeaderProvider
} from '../../statspro/js/providers';

( function ( app, common ) {

    /**
     * renderMap will contain a mapping of React "Provider" components to DOM selectors.
     * The React "component" will be rendered into any DOM elements matching the "node" selector.
     */
    const renderMap = [
        { node: '.js-react-default-table-provider', component: DefaultTableProvider },
        { node: '.js-react-default-table-modal-provider', component: DefaultTableModalProvider },
        { node: '.js-react-custom-ladder-provider', component: LadderTableProvider },
        { node: '.js-react-custom-rankings-provider', component: RankingsTableProvider },
        { node: '.js-react-player-stats-table-provider', component: PlayerStatsTableProvider },
        { node: '.js-react-statspro-nav-provider', component: StatsProHeaderProvider },
        { node: '.js-react-statspro-statsleaders-provider', component: StatsLeadersProvider }
    ];

    /**
     * Filter a list of DOM nodes to those that exist on the page,
     * Get a reference to the Nodes and map them to a React component,
     * Create a React Portal for each Node (so we can render React components into the same React tree, but not the same DOM tree).
     *
     * history can be used to pass in a reference to the value of the `history/createBrowserHistory` package function,
     * in case we need a package like "connected-react-router" to sync router state with the redux store.
    */
    const render = ( renderMap, history ) => {
        const children = renderMap.filter( item => document.querySelector( item.node ) )
            .map( item => [ ...document.querySelectorAll( item.node ) ].map( node => ( { node, component: item.component } ) ) )
            .flat()
            .map( item => {
                return ReactDOM.createPortal(
                    // we could alternatively spread "data" here if we don't want to nest any attributes
                    React.createElement( item.component, { store: app.redux.store, history, data: item.node.dataset } ),
                    item.node
                );
            } );

        // if we have any matching DOM selectors, render the matching React components
        if ( children.length ) {
            ReactDOM.render(
                React.createElement(
                    Fragment,
                    null,
                    children,
                ),
                document.createElement( 'div' ),
            );
        }
    };

    const depsLoaded = ( resolve ) => {
        if ( typeof PULSE.app.redux !== 'undefined' && typeof PULSE.app.redux.store !== 'undefined' ) {
            resolve();
        } else {
            document.addEventListener( common.CONSTANTS.STORE.READY, resolve );
        }
    };

    // wait for the Redux store to load, then run the bootstrap process
    const depsLoadedPromise = new Promise( depsLoaded );
    depsLoadedPromise.then( () => render( renderMap ) );

} ( PULSE.app, PULSE.app.common ) );
